import ids from '@iris-platform/ids-js-sdk';
import { resolver } from '../util';
import config from '../../config';
import getToken from '../../util/getToken';
import {
  handleHttpErrors,
  RequestFailureError,
  UnknownResponseError,
} from '../errors';

function getTime(time) {
  const dateLimit = new Date();
  if (time === 'day') {
    dateLimit.setDate(dateLimit.getDate() - 1);
  } else if (time === 'three_day') {
    dateLimit.setDate(dateLimit.getDate() - 3);
  } else {
    dateLimit.setDate(dateLimit.getDate() - 7);
  }
  return dateLimit.toISOString();
}

const apiResponseTimes = resolver.authenticatedResolver.createResolver(
  async (root, { server, time }) => {
    const servToken = await getToken('reports');
    const dateLimit = getTime(time);
    return ids
      .queryObjects({
        url: config.idsServiceUrl,
        token: servToken,
        className: 'apiResponseTimeData',
        userId: 'api_response_time_reports',
        query: {
          servertype: server,
          time_bucket: { $gte: dateLimit },
        },
        sort: { time_bucket: -1 },
        skip: 0,
        getCount: 1,
      })
      .then((response) => {
        const times = [];
        if (response !== '') {
          response.result.forEach((element) => {
            times.push(element);
          });
        }
        return times;
      })
      .catch((error) => {
        if (error.response) {
          return handleHttpErrors(error);
        }
        if (error.request) {
          throw new RequestFailureError();
        } else {
          throw new UnknownResponseError();
        }
      });
  },
);

const getAPIServices = resolver.authenticatedResolver.createResolver(
  async () => {
    const dateLimit = new Date();
    dateLimit.setDate(dateLimit.getDate() - 1);
    const servToken = await getToken('reports');
    return ids
      .queryObjects({
        url: config.idsServiceUrl,
        token: servToken,
        className: 'apiResponseTimeData',
        userId: 'api_response_time_reports',
        query: {
          time_bucket: { $gte: dateLimit },
        },
        sort: { time_bucket: -1 },
        skip: 0,
        limit: 300,
        getCount: 1,
      })
      .then((response) => {
        const uniqueAPIs = new Set();
        if (response !== '') {
          response.result.forEach((element) => {
            uniqueAPIs.add(element.servertype);
          });
        }
        return [...uniqueAPIs];
      })
      .catch((error) => {
        if (error.response) {
          return handleHttpErrors(error);
        }
        if (error.request) {
          throw new RequestFailureError();
        } else {
          throw new UnknownResponseError();
        }
      });
  },
);

export default {
  Query: {
    apiResponseTimes,
    getAPIServices,
  },
};
